import type { Wildlife } from "@cloudnest/cascadia-engine";
import { WILDLIFE_LETTER } from "@cloudnest/cascadia-engine";

/**
 * Cascadia placeholder wildlife token — board-game-client copy.
 *
 * Originally derived from the (removed) board-game-playground for visual parity. UI is NOT shared (CLAUDE.md).
 * Colored circle with a single-letter label (B / E / S / H / X).
 */
export interface PlaceholderWildlifeProps {
  readonly x: number;
  readonly y: number;
  readonly radius: number;
  readonly species: Wildlife;
  readonly isDraftable?: boolean;
  readonly isSelected?: boolean;
  readonly testId?: string;
}

const SPECIES_FILL: Record<Wildlife, string> = {
  bear: "var(--cn-cascadia-wild-bear)",
  elk: "var(--cn-cascadia-wild-elk)",
  salmon: "var(--cn-cascadia-wild-salmon)",
  hawk: "var(--cn-cascadia-wild-hawk)",
  fox: "var(--cn-cascadia-wild-fox)",
};

export function PlaceholderWildlife({
  x,
  y,
  radius,
  species,
  isDraftable = false,
  isSelected = false,
  testId,
}: PlaceholderWildlifeProps) {
  return (
    <g
      data-testid={testId ?? `placeholder-wildlife-${species}`}
      data-species={species}
    >
      {isSelected ? (
        <circle
          cx={x}
          cy={y}
          r={radius * 1.25}
          fill="none"
          stroke="var(--cn-cascadia-selection)"
          strokeWidth={radius * 0.18}
        />
      ) : null}
      <circle
        cx={x}
        cy={y}
        r={radius}
        fill={SPECIES_FILL[species]}
        stroke="var(--cn-cascadia-tile-outline)"
        strokeWidth={1}
        opacity={isDraftable ? 1 : 0.9}
      />
      <text
        x={x}
        y={y + radius * 0.35}
        textAnchor="middle"
        fontSize={radius * 1.05}
        fontWeight={700}
        fill="var(--cn-cascadia-bg)"
        style={{ pointerEvents: "none", userSelect: "none" }}
      >
        {WILDLIFE_LETTER[species]}
      </text>
    </g>
  );
}
